import { CrudOptions, MenuState } from "components/Category/CrudMenu";
import { FormikContextType, useField, useFormikContext } from "formik";
import { defaultRedirectAction } from "../WorkFlowAction";
import { formatDateString } from "../HomeDashboard";
import { parseListDate } from "helpers/parseListDate";

type Props = {
  fieldName: string;
  label: string;
  readOnly?: boolean;
  actions?: MenuState[1];
};

export const WorkFlowProgress = <T,>(props: Props) => {
  const { fieldName, label, actions } = props;
  const formikContext = useFormikContext<FormikContextType<T>>();
  const [field] = useField<any>(fieldName);

  const items: any[] = field.value?.sort(
    (a: any, b: any) => a.orderNumber - b.orderNumber
  );

  return (
    <div className="FormBox FormSideBySide WorkFlowProgress">
      <div className="FormLabel">
        <h4>{label}</h4>
        {actions && (
          <a
            onClick={() => {
              actions?.closeMenus();
              actions?.openMenu(
                defaultRedirectAction.menuType as CrudOptions,
                null
              );
              return false; //prevent default action
            }}
          >
            view workflow
          </a>
        )}
      </div>
      <div className="FormField">
        <div className="GatewayTasksFieldRenderer ReadOnly">
          {field.value &&
          Array.isArray(field.value) &&
          field.value.length > 0 ? (
            <div className="Tasks">
              {items?.map((item, idx) => {
                const isGreen = item.bCompleted;
                const isRed =
                  !isGreen &&
                  (idx === 0 || items[idx - 1].bCompleted) &&
                  (idx === items.length - 1 || !items[idx + 1].bCompleted);

                return (
                  <div
                    className={`Task ${
                      isGreen ? "Green" : isRed ? "Red" : "Grey"
                    }`}
                    key={`task-${idx}`}
                  >
                    <div
                      className={`TaskCircle ${
                        isGreen ? "Green" : isRed ? "Red" : "Grey"
                      }`}
                      key={`task-circle-${idx}`}
                    ></div>
                    <div className="TaskName" key={`task-name-${idx}`}>
                      {item.name ?? "-"}
                    </div>
                    <ul>
                      {/* {item.bCompleted && (
                        <li
                          className="AssigneeOrCompletionDate"
                          key={`task-completed-${idx}`}
                        >
                          {`Completed ${
                            item.completionDate
                              ? formatDateString(
                                  item.completionDate,
                                  "dd-MMM-yyyy"
                                )
                              : ""
                          }`}
                        </li>
                      )} */}

                      {item.description && (
                        <li
                          className="Description"
                          key={`task-description-${idx}`}
                        >
                          {item.description}
                        </li>
                      )}

                      {item.completionDate && (
                        <li
                          className="CompletionDate"
                          key={`task-completion-date-${idx}`}
                        >
                          {`Completed: ${parseListDate(
                            item.completionDate,
                            false
                          )}`}
                        </li>
                      )}

                      {item.completedBy && (
                        <li
                          className="CompletedBy"
                          key={`task-completed-by-${idx}`}
                        >
                          {`Completed by: ${item.completedBy}`}
                        </li>
                      )}

                      {item.comments && (
                        <li className="Comments" key={`task-comments-${idx}`}>
                          {`${item.comments}`}
                        </li>
                      )}

                      {item.reasonCode && (
                        <li
                          className="ReasonCode"
                          key={`task-reason -code-${idx}`}
                        >
                          {`Reason code: ${item.reasonCode}`}
                        </li>
                      )}

                      {item.contactTypes && (
                        <li className="ContactTypes">
                          Contact types: {item.contactTypes}
                        </li>
                      )}

                      {item.userPool && (
                        <li className="UserPool">User pool: {item.userPool}</li>
                      )}
                    </ul>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="NoData">No tasks </div>
          )}
        </div>
      </div>
    </div>
  );
};
